import { validate as validateUUID } from 'uuid';

export type VideoUrls = {
  videoUrl: string;
  subtitleUrl: string;
  posterUrl: string;
};

const contentAssetsUrl = window.__sparxweb.urls.contentAssets;
export const makeQuestionVideoUrls = (videoId: string): VideoUrls => ({
  posterUrl: `${contentAssetsUrl}/${videoId}/poster`,
  subtitleUrl: `${contentAssetsUrl}/${videoId}/subtitles`,
  videoUrl: `${contentAssetsUrl}/${videoId}`,
});

export const staticAssetsUrl = window.__sparxweb.urls.staticAssets;
export const makeStaticVideoUrls = (videoId: string, extendedPath = false) => {
  return {
    posterUrl: `${staticAssetsUrl}/${videoId}${extendedPath ? '.poster' : ''}.png`,
    subtitleUrl: `${staticAssetsUrl}/${videoId}${extendedPath ? '.subtitles' : ''}.vtt`,
    videoUrl: `${staticAssetsUrl}/${videoId}.mp4`,
  };
};

const onboardingAssetBaseUrl = `${window.__sparxweb.urls.staticAssets}/assets/student-onboarding`;
export const makeOnboardingVideoUrls = (key: string): VideoUrls => ({
  videoUrl: `${onboardingAssetBaseUrl}/${key}.mp4`,
  subtitleUrl: `${onboardingAssetBaseUrl}/${key}.subtitles.vtt`,
  posterUrl: `${onboardingAssetBaseUrl}/${key}.poster.png`,
});

// Shared function provided to SparxQuestion to ensure the correct domain is used.
// This is a duplication of the default asset getter used in @sparx/question but with a configurable
// domain.
export const getAssetUrl = async (src: string) => {
  if (validateUUID(src)) {
    return `${contentAssetsUrl}/${src}`;
  }
  return src;
};

// This is similar to getAssetUrl but isn't async
export const getImageURL = (imageID: string) => `${contentAssetsUrl}/${imageID}`;
